import React, { useEffect } from 'react';

import Layout from '../../containers/Layout';
import { Container, Content } from './styles';
import ImageTitle, { Icons } from '../../components/ImageTitle';
import { useCheckoutGtm } from '../../hooks/gtm/checkout/useCheckoutGtm';
import LgpdCard from '../../components/LgpdCard';
import { getLocationState } from '../../utils/routes.util';
import { LGPDInvite } from '../../requests/interfaces/commons.interface';
import { Order } from '../../requests/caipirinha-api/interfaces/order.interface';
import LocalStorageService from '../../services/local-storage.service';
import MessageToken from '../../containers/MessageToken';

const PaymentSuccess: React.FC<any> = (props: any) => {
  const order: Order | undefined = getLocationState(props, 'order');
  const lgpd: LGPDInvite | undefined = getLocationState(props, 'lgpd');
  const showMessageToken = LocalStorageService.getItem<boolean>('showMessageToken') || false;
  const { sendDataToGtm } = useCheckoutGtm();

  useEffect(() => {
    if (order)
      sendDataToGtm(order, {
        type: 'checkout',
        name: '/pagamento/confirmacao-transacao',
      });
  }, [order]);

  return (
    <Layout dark>
      <Container>
        <ImageTitle
          data-cy='confirm-payment'
          icon={Icons.success}
          text="Obrigado por comprar no Magalu!"
          primary
        />
        <Content data-cy="awaiting-payment-message">
          Nós recebemos a sua solicitação e agora estamos aguardando a aprovação
          do pagamento, que pode levar até 2 horas.
        </Content>
        <Content data-cy="whatsapp-info-message">
          Em breve voltamos para te contar os próximos passos do seu pedido, no
          Whatsapp da Lu do Magalu.
        </Content>

        { showMessageToken && <MessageToken /> }

      </Container>
      {lgpd?.self && <LgpdCard url={lgpd.self.offerPolicy} />}
    </Layout>
  );
};

export default PaymentSuccess;
